import React from "react";
import { Typography, Space, Tag } from "antd";
import { isRemovedJobParent } from "../../util/removedJobGuards";

const { Text } = Typography;

const OP_LABEL = { 
  gte: "≥", 
  lte: "≤", 
  gt: ">", 
  lt: "<", 
  eq: "=", 
  neq: "≠", 
  contains: "contains", 
  is: "is", 
  exists: "Exists", 
  not_exists: "Not Exists", 
  is_passed: "Is Passed", 
  is_failed: "Is Failed"
};

const PARENT_COLOR = { 
  all: "default", 
  molprops: "green", 
  glide: "volcano", 
  phase: "geekblue", 
  adme: "purple"
};

const capitalize = (s) => (s && s.replace(/\b\w/g, (l) => l.toUpperCase())) || "";

export const FilterCriteriaDisplay = ({ rules }) => {
  const visibleRules = Array.isArray(rules)
    ? rules.filter((rule) => rule?.parent && !isRemovedJobParent(rule.parent))
    : [];

  if (visibleRules.length === 0) {
    return <Text type="secondary">No filters were applied.</Text>;
  }

  const formatRule = (r) => {
    const parent = r.parentLabel || capitalize(r.parent || "all");
    const op = OP_LABEL[r.op] || r.op;
    const child = r.childLabel || r.child;
    const value = r.value !== undefined && r.value !== "" ? String(r.value) : null;
    
    return {
      parent,
      child: child && child.toLowerCase() !== "all" ? child : null,
      op,
      value,
      color: PARENT_COLOR[r.parent] || "default"
    };
  };

  return (
    <div style={{ 
      maxHeight: "150px", 
      overflowY: "auto", 
      padding: "8px",
      width: "100%"
    }}>
      <Space wrap align="center" size={[8, 8]} style={{ width: "100%" }}>
        {visibleRules.map((rule, index) => {
          const formatted = formatRule(rule);
          return (
            <React.Fragment key={rule.id || index}>
              {index > 0 && <Text strong>{capitalize(rule.glue || "and")}</Text>}
              <Tag color={formatted.color} style={{ marginRight: 0 }}>
                <Space size="small" style={{ flexWrap: "nowrap" }}>
                  <Text strong style={{ whiteSpace: "nowrap" }}>{formatted.parent}</Text>
                  {formatted.child && <Text style={{ whiteSpace: "nowrap" }}>• {formatted.child}</Text>}
                  <Text style={{ whiteSpace: "nowrap" }}>• {formatted.op}</Text>
                  {formatted.value && (
                    <Text 
                      style={{ 
                        maxWidth: "200px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "inline-block"
                      }}
                      title={formatted.value}
                    >
                      • {formatted.value}
                    </Text>
                  )}
                </Space>
              </Tag>
            </React.Fragment>
          );
        })}
      </Space>
    </div>
  );
};
